import React, { Component } from "react";

class Popup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            motivoId: 0,
            esValido: false,
            validaCambo: (props.mostrarCombo == true || props.mostrarCombo == undefined)
        }
        this.selectCombo = this.selectCombo.bind(this);
        this.validarMotivo = this.validarMotivo.bind(this);
    }
    /**
     * 
     * @param {any} event
     */
    selectCombo(event) {
        this.setState({ motivoId: event.target.value, esValido: (event.target.value != 0) },
            this.props.selectCombo(event.target.value));
    }
    /**
     * 
     */
    validarMotivo() {
        if (this.state.motivoId == 0 && this.state.validaCambo) {
            this.setState({ esValido: false });
        } else {
            this.props.confirmar((!this.state.validaCambo ? undefined : this.state.motivoId));
        }
    }
    /**
     * 
     */
    componentDidMount() {
        const { clave } = this.props;
        /*lamentablmente necesario para evitar que se cierre el dropdown cuando el usuario hace click sobre el contenido*/
        $(`#${clave} .dropdown-menu`).on({
            "click": function (e) {
                /*si no hay que ejecutar entonces bloqueo la accion*/
                if (e.target.dataset.ejecutar == "true") {
                    /*validar que hacer en caso de ejecutar*/
                    if (e.target.dataset.motivo == "false") {
                        e.stopPropagation();
                    }
                } else {
                    e.stopPropagation();
                }
            }
        });
    }
    /**
     * 
     */
    render() {
        /*Atributos*/
        const { children, clave, motivos, titulo, mensajeError, mostrarCombo } = this.props;

        return (
            <div className="popup-tarjetas-bloqueo">
                <div className="dropdown" id={clave}>
                    {children}
                    <ul className="dropdown-menu dropdown-menu-right">
                        <div className="top-popup">
                            <li>
                                <label className="label-primary">{titulo}</label>
                            </li>
                            {this.state.validaCambo &&
                                <li>
                                    <select value={this.state.motivoId} className="form-control" onChange={this.selectCombo}>
                                        <option value="0">Seleccione...</option>
                                        {motivos.map((motivo, index) => {
                                            return (
                                                <option value={motivo.Id} key={index}>{motivo.Descripcion}</option>
                                            )
                                        })}
                                    </select>
                                </li>
                            }
                            {(this.state.validaCambo && this.state.esValido == false) &&
                                <li className="top-separator-xxs"><label className="error">{mensajeError}</label></li>}

                            <li className="top-separator-xxs">
                                <div className="text-right">
                                    <button type="button"
                                        className="btn btn-cta"
                                        data-ejecutar={true}
                                        data-motivo={(this.state.validaCambo ? this.state.esValido : true)}
                                        onClick={this.validarMotivo}>Listo</button>
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Popup;